<ng-container *ngIf="property$ | async as property">
  <div class="w-[250px]">
    <div class="h-[165px] mb-4 photos-slider-container">
      <a target="_blank" [routerLink]="[property.code]">
        <div class="swiper h-full">
          @if(!loadingPhotos){
          <ng-container *ngIf="photos$ | async as photos">
            <div class="swiper-wrapper">
              <div class="swiper-slide" *ngFor="let photo of photos.items">
                <div
                  class="rounded-lg md:aspect-[270/180] aspect-[32/22] relative overflow-hidden flex-1 md:max-w-[250px]">
                  <img #windowPhoto [src]="photo.uri" (error)="windowPhoto.src=photo.fallbackUri ?? cardImage"
                    class="w-full h-full object-cover" />

                  <div class="absolute inset-0 flex flex-col justify-between items-start overflow-hidden">
                    <div class="flex gap-2 p-3 flex-wrap">
                      <div *ngIf="property.auctionRound && !property.isSold"
                        class="py-1 px-2 flex items-center justify-center rounded-full bg-[#3B61C1] text-white text-[0.625rem] font-bold w-fit leading-none whitespace-nowrap">
                        ΠΛΕΙΣΤΗΡΙΑΣΜΟΣ
                      </div>
                      <div *ngIf="property.isSponsored && !property.isSold"
                        class="py-1 px-2 flex items-center justify-center rounded-full bg-[#DC7312] text-white text-[0.625rem] font-bold w-fit leading-none whitespace-nowrap">
                        SPONSORED
                      </div>
                      <div *ngIf="property.isExclusive && !property.isSold"
                        class="py-1 px-2 gap-[6px] flex items-center justify-center rounded-full bg-[#059B9C] text-white text-[0.625rem] font-semibold w-fit leading-none whitespace-nowrap">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10 5.12333V9.74463C10 9.8861 9.87618 10 9.72416 10H8.78928C8.63647 10 8.51266 9.88538 8.51266 9.74463V5.3446C8.51266 5.28366 8.48915 5.22417 8.44526 5.17774L5.20884 1.7027C5.09835 1.58445 4.90087 1.58445 4.79038 1.7027L1.55395 5.17774C1.51085 5.22417 1.48656 5.28366 1.48656 5.3446V8.65569C1.48656 8.79716 1.61038 8.91106 1.76318 8.91106H4.01144C4.16425 8.91106 4.28806 8.79643 4.28806 8.65569V5.8713C4.28806 5.72983 4.41188 5.61521 4.56469 5.61521H5.44315C5.59596 5.61521 5.71977 5.72983 5.71977 5.8713V9.74391C5.71977 9.88537 5.59596 9.99928 5.44315 9.99928H0.276624C0.123815 9.99928 0 9.88465 0 9.74391V5.12261C0 5.05949 0.0250764 4.99855 0.0705274 4.95139L4.79429 0.084881C4.904 -0.0282937 5.09521 -0.0282937 5.20492 0.084881L9.92869 4.95212C9.97414 4.99927 9.99922 5.06021 9.99922 5.12333H10Z"
                            fill="white" />
                        </svg>
                        <span>UNIKO EXCLUSIVE</span>
                      </div>
                      <div *ngIf="property.isHot && !property.isSold"
                        class="py-1 px-2 flex items-center justify-center rounded-full bg-[#D93535] text-white text-[0.625rem] font-semibold w-fit leading-none whitespace-nowrap">
                        <i class="icon-fire-alt mr-1"></i>
                        <span>HOT</span>
                      </div>
                    </div>
                    @if (property.preApproved == 'Approved' && !property.isSold)
                    {
                    <div
                      class="bg-[#037079CC] flex justify-center p-[6px] gap-[6px] w-full items-center backdrop-blur-sm rounded-b-lg overflow-hidden">
                      <span class="text-white text-[10px] leading-none font-bold block">ΠΙΣΤΟΠΟΙΗΜΕΝΟ ΑΠΟ ΤΗΝ</span>
                      <img src="{{
                          '../../../../assets/svgs/nbg-logo' +
                            (activeLang === 'el' ? '-white' : '') +
                            '.svg'
                        }}" alt="Brand Logo" class="w-[66px] object-cover object-center img-disable-context" />
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          }
        </div>
      </a>
      <div class="swiper-button-next slider-next-button w-[20px] h-[20px] bg-white text-black rounded-full"></div>
      <div class="swiper-button-prev slider-prev-button w-[20px] h-[20px] bg-white text-black rounded-full"></div>

      <div class="custom-swiper-pagination"></div>
    </div>
    <div class="font-[Averta] p-3">
      <div class="flex items-center justify-between gap-2">
        <h3 class="font-bold text-black text-base">
          {{ property.title !== "" ? property.title : "-" }}
          {{ property.propertyArea ? ", " + property.propertyArea + "τμ" : "" }}
        </h3>
        @if (!property.isSold) {
        <button
          class="p-4 rounded-full w-10 h-10 flex items-center self-start justify-center bg-gray-100 text-primary-600 hover:bg-gray-200 transition-colors"
          (click)="toggleFavorite($event)">
          <i [ngClass]="
              property.isFavorite
                ? 'icon-heart-filled text-primary'
                : 'icon-heart-line'
            "></i>
        </button>
        }
      </div>

      <div class="text-gray-900 text-sm mb-3">
        {{ property.address?.prefecture }}
      </div>
      <div class="flex items-center justify-between gap-2">
        <div class="font-bold text-black text-base">
          €{{ property.price | number }}
        </div>
        @if (property.auctionRound && property.auctionRound != 0) {
        <div class="text-[#3B61C1] text-sm font-semibold block flex items-center gap-2">
          @switch (property.auctionRound) { @case (1) { 1ος } @case (2) { 2ος }
          @case (3) { 3ος } @case (4) { 4ος } @default {} } γύρος
        </div>
        }
      </div>
    </div>
  </div>
</ng-container>